import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import { Secured } from 'infrastructure/security';
import { ErrorBoundary, ErrorPage, NotFound } from 'infrastructure/error';
import { withCurrentUser } from 'infrastructure/currentUser';
import { withMenu } from 'infrastructure/menu';
import logo from 'img/logo/newsletter-tool-logo.svg';

import { compose } from 'recompose';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faTag, faUsers } from '@fortawesome/pro-light-svg-icons';
import LogIn from 'slices/Account/Loadable';
import MainWrapper from 'containers/App/MainWrapper';
import Send from 'slices/Send/Loadable';
import User from 'slices/User/Loadable';
import Settings from 'slices/Settings/Loadable';
import { Chip, TopRightNav } from 'components';
import URI from 'urijs';
import GlobalAppWrapper from 'components/GlobalAppWrapper/GlobalAppWrapper';
import {
  withConfig,
  propTypes as configPropTypes,
} from 'infrastructure/config';

const isCurrent = (url, pathname) =>
  pathname &&
  (pathname.split('/')[1]
    ? url.includes(pathname.split('/')[1])
    : pathname.includes(url)) &&
  URI(url).is('relative');

const setType = menuItem => {
  let type = null;
  if (menuItem.items && menuItem.items.length > 0) {
    type = 'parent';
  } else if (menuItem.name.toLowerCase() === 'separator') {
    type = 'separator';
  } else if (menuItem.url.startsWith('http')) {
    type = 'externalLink';
  }
  return type;
};

const addSidebarLinks = (sidebarLinks, menuItems, pathname, currentTenant) => {
  menuItems.forEach(menuItem => {
    const sidebarLink = {
      ...menuItem,
      current: isCurrent(menuItem.url, pathname),
      items: [],
      type: setType(menuItem),
    };

    if (sidebarLink.type === 'parent') {
      addSidebarLinks(
        sidebarLink.items,
        menuItem.items,
        pathname,
        currentTenant
      );
    }
    sidebarLinks.push(sidebarLink);
  });
};

const enhance = compose(withConfig, withMenu, withCurrentUser, withRouter);

const wrappedRoutes = enhance(props => {
  const {
    location,
    currentUser: { isSystemAdmin },
    currentTenant,
    menu,
    config,
  } = props;
  const background = location && location.state && location.state.background;
  const environment = config && config.environment;
  const environmentBadgeColor = environment === 'QA' ? 'info' : 'success';

  const sidebarLinks = [];

  if (menu && menu.items) {
    addSidebarLinks(sidebarLinks, menu.items, location.pathname, currentTenant);
  }

  const iconMap = {
    'cms users': <FontAwesomeIcon icon={faUsers} />,
    'gma wake-up': <FontAwesomeIcon icon={faSun} />,
    'deals & steals': <FontAwesomeIcon icon={faTag} />,
  };

  const formattedSidebarLinks = sidebarLinks.map(navPoint =>
    Object.assign(navPoint, {
      icon: iconMap[navPoint.name && navPoint.name.toLowerCase()],
    })
  );

  return (
    <Secured>
      <GlobalAppWrapper
        logo={<img src={logo} alt="Newsletter Tool" />}
        title="Example"
        sidebarLinks={formattedSidebarLinks}
        topbarContentRight={<TopRightNav />}
        topbarContentLeft={
          <Chip color={environmentBadgeColor}>{environment}</Chip>
        }
      >
        {!isSystemAdmin && (
          <ErrorBoundary>
            <Switch location={background || location}>
              <Route path="/gma-wake-up" component={Send} />
              <Route path="/deals-and-steals" component={Send} />
              <Route path="/users" component={User} />
              <Route path="/settings" component={Settings} />
              <Route path="*">
                <Redirect to="/gma-wake-up" />
              </Route>
            </Switch>
          </ErrorBoundary>
        )}
        {/* {isSystemAdmin && (
          <ErrorBoundary>
            <Switch location={background || location}>
              <Route path="/tenant" component={Tenant} />
              <Route path="*">
                <Redirect to="/tenant" />
              </Route>
            </Switch>
          </ErrorBoundary>
        )} */}
      </GlobalAppWrapper>
    </Secured>
  );
});

wrappedRoutes.propTypes = {
  location: PropTypes.shape({}),
  config: configPropTypes.isRequired,
};

wrappedRoutes.defaultProps = {
  location: {},
};

const AppRouter = props => {
  const { className } = props;
  return (
    <MainWrapper className={className}>
      <main>
        <Switch>
          <Route exact path="/login" component={LogIn} />
          <Route path="/error" component={ErrorPage} />
          <Route path="/500" component={ErrorPage} />
          <Route path="/404" component={NotFound} />
          <Route path="/" component={wrappedRoutes} />
        </Switch>
      </main>
    </MainWrapper>
  );
};

AppRouter.propTypes = {
  className: PropTypes.string,
};

AppRouter.defaultProps = {
  className: '',
};

export default AppRouter;
